import { Component, OnInit,Input } from '@angular/core';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {
  activeSpinner : boolean;
  totalstateschartdata : any;
  nonhimchartdata : any;
  himchartdata  : any
  unionchartdata :any;
  chartData = {};
  assesmentyear;
  AssesmentList = [];
  // commonChartTemp = {
  //   "title" : null,
  //   "seriesdata" :[{
  //     name : null,
  //     "data" :[{
  //       name : "Completed",
  //       y : null,
  //       color : "green"
  //     },
  //     {
  //       name : "Not Started",
  //       y : null,
  //       color : "#c51815"
  //     }]
  //   }]
  // };
  // titlesobj = {
  //   totalstateschartdata : "Total States",
  //   nonhimchartdata : "Non Himalayan States",
  //   himchartdata : "North-eastern and Himalayan States",
  //   unionchartdata : "Union Territories"
  // }

  constructor(private constants : ConstantsModule,
    private submitdataSerivce : SubmitdataService) { }

  ngOnInit() {
    this.submitdataSerivce.getStatusOfToken();
    this.getdynamicYears();
    // this.AssesmentList = this.submitdataSerivce.getassesmentYear();
    // this.assesmentyear = this.AssesmentList[this.AssesmentList.length-1];
    // this.getDataForPieChart();
  }
  getdynamicYears(){
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }    
    // this.AssesmentList = this.submitdataSerivce.getassesmentYear();
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.AssesmentList = data['data'];
    });
    this.assesmentyear = dropDownYear;
  }
  getDataForPieChart(){
    this.activeSpinner = true;
    let postdata = {
      "cType" : this.constants.LOCATION_CONSTANT['STATE'],
      "pType" : this.constants.LOCATION_CONSTANT['REGION'],
      "ay" : this.assesmentyear,
      "view" : "admin"
    }
    this.submitdataSerivce.getPieChartData(postdata).subscribe(data =>{
      // let data = {"NORTH EASTERN AND HIMALAYAN":{"notstarted":4,"inprogress":9,"completed":0,"waitingforapproval":0},"NON HIMALAYAN":{"notstarted":5,"inprogress":18,"completed":0,"waitingforapproval":0},"ALL":{"notstarted":9,"inprogress":27,"completed":0,"waitingforapproval":0}};
      this.chartData = data;
      console.log(data);
      this.totalstateschartdata = {
        "title" : "Total States",
        "showlegend" : false,
        "size" : "100%",
        "width" : "100px",
        "margin": 0,
        "titlex" : 0,
        "titlealign" : "center",
        "seriesdata" : [{
          name: 'Total States',
          colorByPoint: true,
          data: [{
              name: 'Completed',
              y: this.chartData ? this.chartData['ALL'] ? this.chartData['ALL']['completed'] : null :null,
              color : 'green'
          }, {
              name: 'Not Started',
              y:  this.chartData ? this.chartData['ALL'] ? this.chartData['ALL']['notstarted']:null:null,
              color : '#c51815'
          },{
            name: 'In Progress',
            y:  this.chartData ? this.chartData['ALL'] ?this.chartData['ALL']['inprogress'] :null:null,
            color : 'yellow'
        }, {
            name: 'Waiting For Approval',
            y: this.chartData ? this.chartData['ALL'] ?this.chartData['ALL']['waitingforapproval'] :null:null,
            color : 'orange'
        }]
      }]
      }
      this.nonhimchartdata = {
        "title" : "Non Himalayan States",
        "showlegend" : false,
        "size" : "60%",
        "width" : "100px",
        "margin": 0,
        "titlex" : 0,
        "titlealign" : "center",
        "seriesdata" : [{
          colorByPoint: true,
          data: [{
              name: 'Completed',
              y: this.chartData['NON HIMALAYAN']['completed'],
              color : 'green'
          }, {
              name: 'Not Started',
              y: this.chartData['NON HIMALAYAN']['notstarted'],
              color : '#c51815'
          },{
            name: 'In Progress',
            y: this.chartData['NON HIMALAYAN']['inprogress'],
            color : 'yellow'
          }, {
              name: 'Waiting For Approval',
              y: this.chartData['NON HIMALAYAN']['waitingforapproval'],
              color : 'orange'
          }]
      }]
      }
      this.himchartdata = {
        "title" : "North-eastern and Himalayan States",
        "showlegend" : false,
        "size" : "60%",
        "width" : "100px",
        "margin": 0,
        "titlex" : 0,
        "titlealign" : "center",
        "seriesdata" : [{
          colorByPoint: true,
          data: [{
              name: 'Completed',
              y: this.chartData['NORTH EASTERN AND HIMALAYAN']['completed'],
              color : 'green'
          },{
              name: 'Not Started',
              y: this.chartData['NORTH EASTERN AND HIMALAYAN']['notstarted'],
              color : '#c51815'
          },{
            name: 'In Progress',
            y: this.chartData['NORTH EASTERN AND HIMALAYAN']['inprogress'],
            color : 'yellow'
          }, {
              name: 'Waiting For Approval',
              y: this.chartData['NORTH EASTERN AND HIMALAYAN']['waitingforapproval'],
              color : 'orange'
          }]
      }]
      }
      this.unionchartdata = {
        "title" : "Union Territories",
        "showlegend" : true,
        "size" : "40%",
        "width" : "500px",
        "margin": 150,
        "titlex" : 40,
        "titlealign" : "left",
        "seriesdata" : [{
          colorByPoint: true,
          data: [{
              name: 'Completed',
              y: this.chartData['UNION TERRITORIES'] ? this.chartData['UNION TERRITORIES']['completed']: null,
              color : 'green'
            }, {
              name: 'Not Started',
              y: this.chartData['UNION TERRITORIES'] ? this.chartData['UNION TERRITORIES']['notstarted']: null,
              color : '#c51815'
            },{
              name: 'In Progress',
              y: this.chartData['UNION TERRITORIES'] ? this.chartData['UNION TERRITORIES']['inprogress']: null,
              color : 'yellow'
            },{
                name: 'Waiting For Approval',
                y: this.chartData['UNION TERRITORIES'] ? this.chartData['UNION TERRITORIES']['waitingforapproval']: null,
                color : 'orange'
            }]
      }]
      }
      this.activeSpinner = false;
    },function(error){
      this.activeSpinner = false;
    });
  }

}
